/* unplugin-vue-components disabled */import script from "./chart.vue?vue&type=script&setup=true&lang=js"
export * from "./chart.vue?vue&type=script&setup=true&lang=js"

import "./chart.vue?vue&type=style&index=0&id=fecce7a6&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fecce7a6"]])

export default __exports__